<!-- <div class="btn-float">
	<i class="bi bi-file-earmark-plus-fill"></i>
</div> -->

<div class="dashboard-card list-card" *ngIf="myInst()" [class.subody]="user.subscribe">
  <!-- <div class="widget-header">
    <h5>
      Institutes List
    </h5>

		@if(user && !user.erp_key) {
		<select class="form-select" style="width: 40%;" [(ngModel)]="org_id">
				<option value="0">
						Select Organization
				</option>
				@for(o of orgs; track $index) {
						<option value="{{o.id}}">{{o.org_name}}</option>
				}
		</select>
		}

    <button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
      +Add New
    </button>
  </div>

	<div class="w-100">
		<table id="orgTable" class="table table-striped w-100">
			<thead>
				<tr>
					<th>#</th>
					<th>Name</th>
					<th>Type</th>
					<th>Mobile</th>
					<th>Email</th>
					<th>City</th>
					<th>Reg. Date</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				@for(data of allData; track $index; let idx = $index;) {
				<tr>
					<td>{{idx+1}}.</td>
					<td>{{data.inst_name}}</td>
					<td>{{dataService.getInstituteType(data?.inst_type)}}</td>
					<td>{{data.phone_no}}</td>
					<td>{{data.email_id}}</td>
					<td>{{data.city}}</td>
					<td>{{data?.reg_date?.substr(0,10)}}</td>
					<td>{{data.is_active}}</td>
					<td>
						<div class="d-flex gap-2">
							<span class="btn btn-sm btn-primary py-0" style="cursor: pointer;" title="View KYC Details" 
								(click)="modalOpen=true;" data-bs-toggle="modal" data-bs-target="#staticBackdrop2" 
								*ngIf="user.erp_key && user.user_role[0].code!='spr'">
								<i class="bi bi-window-stack"></i> My KYC
							</span>

							<ng-container *ngIf="!user.erp_key && user.user_role[0].code=='spr'">
								<span style="cursor: pointer;" (click)="planClick(data)" title="Package/Plan Details">
									<i class="bi bi-boxes text-dark"></i></span>
								<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
									(click)="editClick(data)" title="Modify">
									<i class="bi bi-pencil-square text-success"></i></span>
								<span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete"><i
										class="bi bi-trash3 text-danger"></i></span>
							</ng-container>
						</div>
					</td>
				</tr>
				}
			</tbody>
		</table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available. <span (click)="ngOnInit()">Refresh Data</span>
		</div>
	</div> -->

      <!-- Hero / Institute Banner -->
      <section class="hero">
        <div class="hero-content">
          <div class="d-flex flex-column flex-md-row align-items-start gap-4">            
            <div class="institute-logo">
              <!-- <i class="bi bi-mortarboard-fill"></i> -->
               <img [src]="myInst()?.logo ? auth.svrUrl + '/uploads/' + user.erp_key + '/logo/' + myInst()?.logo : '/images/inst_logo.png'" width="85%">
            </div>

            <div class="flex-grow-1">
              <h1 class="hero-title">{{myInst()?.inst_name}}</h1>
              <div class="tagline mb-3">Education Today &nbsp; | &nbsp; Better Tomorrow</div>

              <div class="d-flex flex-wrap gap-2">
                <span class="badge-soft badge-approved">
                  <i class="bi bi-check-circle-fill me-1"></i> Approved
                </span>
                <span class="badge-soft badge-type">
                  <i class="bi bi-building-fill me-1"></i> {{dataService.getInstituteType(myInst()?.inst_type)}}
                </span>
                <span class="badge-soft badge-id">
                  Reg. No.: {{myInst()?.reg_no}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Contact / Actions -->
      <section class="contact-strip">
        <div class="row g-0 align-items-center">
          <!-- <div class="col-lg-3 col-md-6 contact-item">
            <div class="d-flex">
              <div class="contact-icon"><i class="bi bi-link-45deg"></i></div>
              <div>
                <div class="contact-label">Website</div>
                <div class="contact-value text-primary">www.sunrisecollege.edu.in</div>
              </div>
            </div>
          </div> -->

          <div class="col-lg-3 col-md-6 contact-item">
            <div class="d-flex">
              <div class="contact-icon"><i class="bi bi-telephone"></i></div>
              <div>
                <div class="contact-label">Contact No.</div>
                <div class="contact-value text-primary">{{myInst()?.phone_no}}</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 contact-item">
            <div class="d-flex">
              <div class="contact-icon"><i class="bi bi-card-text"></i></div>
              <div>
                <div class="contact-label">ERP License</div>
                <div class="contact-value text-primary">{{myInst()?.agr_lickey || 'xxxx-xxxx-xxxx'}}</div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 contact-item">
            <div class="d-flex">
              <div class="contact-icon"><i class="bi bi-geo-alt"></i></div>
              <div>
                <div class="contact-label">Location</div>
                <div class="contact-value">
                  {{myInst()?.address}},<br>
                  {{myInst()?.city}} - {{myInst()?.pincode}} ({{myInst()?.state}})
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-2 mt-3 mt-lg-0">
            <div class="d-flex flex-column gap-2 px-4">
              <button class="btn btn-sm btn-secondary" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
                (click)="editClick(myInst())">Edit</button>
              <button class="btn btn-sm btn-danger" (click)="logout()">Logout</button>
              <!-- <button class="btn btn-outline-primary" title="Back">
                <i class="bi bi-arrow-left"></i>
              </button>
              <button class="btn btn-outline-secondary" title="More">
                <i class="bi bi-three-dots-vertical"></i>
              </button> -->
            </div>
          </div>

        </div>
      </section>

      <!-- Main Details -->
      <div class="p-3 p-md-4">
        <div class="row g-4">
          <!-- Institute Information -->
          <div class="col-xl-8">
            <div class="section-card h-100 p-3 p-md-4">
              <div class="d-flex align-items-center gap-3 mb-3">
                <i class="bi bi-bank section-icon"></i>
                <h2 class="section-title mb-0">Institute Information</h2>
              </div>

              <div class="row gx-5">
                <div class="col-md-6">
                  <div class="info-row">
                    <div class="info-label">Institute Name</div>
                    <div class="info-value">{{myInst()?.inst_name}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Institute Category</div>
                    <div class="info-value">Private</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">ERP Key</div>
                    <div class="info-value">{{myInst()?.org_id}}-{{myInst()?.inst_code}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">ERP Reg. Date</div>
                    <div class="info-value">{{myInst()?.reg_date|date}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">ERP License</div>
                    <div class="info-value">{{myInst()?.agr_lickey || 'xxxx-xxxx-xxxx'}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Approval Status</div>
                    <div class="info-value">
                      <span class="badge rounded-pill text-bg-success">
                        <i class="bi bi-check-circle-fill me-1"></i> Approved
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="info-row">
                    <div class="info-label">Type</div>
                    <div class="info-value">{{dataService.getInstituteType(myInst()?.inst_type)}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Management</div>
                    <div class="info-value">Self Financed</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Total Students</div>
                    <div class="info-value">{{myInst()?.std_cnt}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Total Staff</div>
                    <div class="info-value">{{myInst()?.staff_cnt}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Website</div>
                    <div class="info-value text-primary">{{myInst()?.website}}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">Package Expiry</div>
                    <div class="info-value">{{user.exp_date|date}}</div>
                  </div>
                </div>
              </div>

              <div class="about-box mt-4">
                <div class="d-flex gap-3 align-items-start">
                  <div class="about-icon fs-3">
                    <i class="bi bi-info-circle"></i>
                  </div>
                  <div>
                    <div class="fw-bold mb-1">About the Institute</div>
                    <div class="small text-secondary">
                      {{myInst()?.inst_name}} is a premier educational institution
                      committed to providing quality education, holistic development and
                      creating future-ready professionals.
                    </div>
                  </div>
                  <i class="bi bi-mortarboard-fill ms-auto fs-2 opacity-25 d-none d-md-block"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column -->
          <div class="col-xl-4">

            <!-- Quick Stats -->
            <div class="section-card p-3 p-md-4 mb-4">
              <div class="d-flex align-items-center gap-3 mb-3">
                <i class="bi bi-bar-chart-line section-icon"></i>
                <h2 class="section-title mb-0">Quick Stats</h2>
              </div>

              <div class="row g-3">
                <div class="col-6">
                  <div class="stat-box stat-blue">
                    <!-- <div class="stat-icon text-primary">
                      <i class="bi bi-person-badge"></i>
                    </div> -->
                    <div>
                      <div class="stat-number"><i class="bi bi-person-badge"></i> {{myInst()?.std_cnt}}</div>
                      <div class="stat-label">Total Students</div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="stat-box stat-green">
                    <!-- <div class="stat-icon text-success">
                      <i class="bi bi-people"></i>
                    </div> -->
                    <div>
                      <div class="stat-number"><i class="bi bi-people"></i> {{myInst()?.staff_cnt}}</div>
                      <div class="stat-label">Total Staff</div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="stat-box stat-purple">
                    <!-- <div class="stat-icon text-primary">
                      <i class="bi bi-journal-bookmark"></i>
                    </div> -->
                    <div>
                      <div class="stat-number"><i class="bi bi-bus-front"></i> {{myInst()?.trpt_cnt}}</div>
                      <div class="stat-label">Transports</div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="stat-box stat-yellow">
                    <!-- <div class="stat-icon text-warning">
                      <i class="bi bi-building"></i>
                    </div> -->
                    <div>
                      <div class="stat-number"><i class="bi bi-book"></i> {{myInst()?.books_cnt}}</div>
                      <div class="stat-label">Lib. Books</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Useful Actions -->
            <div class="section-card p-3 p-md-4">
              <div class="d-flex align-items-center gap-3 mb-3">
                <i class="bi bi-lightning-charge section-icon"></i>
                <h2 class="section-title mb-0">Useful Actions</h2>
              </div>

              <div class="row g-3">
                <div class="col-12 col-md-6 col-xl-12 col-xxl-6">
                  <button class="action-btn px-3 d-flex align-items-center"
										(click)="modalOpen=true;" data-bs-toggle="modal" data-bs-target="#staticBackdrop2">
                    <span class="action-circle"><i class="bi bi-book"></i></span>
                    <span class="small fw-semibold">View KYC Details</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </button>
                </div>

                <div class="col-12 col-md-6 col-xl-12 col-xxl-6">
                  <button class="action-btn px-3 d-flex align-items-center"
                    [routerLink]="['/dashboard/', dataService.myEncrypt('adf')]">
                    <span class="action-circle"><i class="bi bi-people"></i></span>
                    <span class="small fw-semibold">View Students</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </button>
                </div>

                <div class="col-12 col-md-6 col-xl-12 col-xxl-6">
                  <button class="action-btn px-3 d-flex align-items-center"
                    [routerLink]="['/dashboard/', dataService.myEncrypt('stf')]">
                    <span class="action-circle"><i class="bi bi-person"></i></span>
                    <span class="small fw-semibold">View Staff</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </button>
                </div>

                <div class="col-12 col-md-6 col-xl-12 col-xxl-6">
                  <button class="action-btn px-3 d-flex align-items-center">
                    <span class="action-circle"><i class="bi bi-download"></i></span>
                    <span class="small fw-semibold">Download Profile</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Institute Form</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<app-inst-form [org_id]="org_id" [user]="user" [action]="btnClick"></app-inst-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal" 
					(click)="btnClick = isEdit ? 'update' : 'save'; reloadData();">
					{{isEdit ? 'Update' : 'Save'}}
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="staticBackdropLabel2" aria-hidden="true" (hidden.bs.modal)="modalOpen = false">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl kyc-body">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalToggleLabel">KYC Details View</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" style="height: 92vh;">
				<app-inst-view *ngIf="modalOpen"></app-inst-view>
			</div>
		</div>
	</div>
</div>
